import type { Control } from "react-hook-form";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { PARSER_OPTIONS, type UploadForm } from "~/utils/upload-form";
import { Card, Form, FormItem, Input, Select } from "~/components/ui";

type SchemaOption = { value: string; label: string };

type UploadConfigFormProps = {
  control: Control<UploadForm>;
  schemaOptions: SchemaOption[];
  schemasLoading: boolean;
};

export function UploadConfigForm({ control, schemaOptions, schemasLoading }: UploadConfigFormProps) {
  const { t } = useTranslation("admin");

  return (
    <Card title={t("uploadAdmin.upload.configuration")} size="small">
      <Form>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <FormItem label={t("uploadAdmin.form.prefix")} tooltip={t("uploadAdmin.form.prefixHint")} className="mb-0">
            <Controller
              name="prefix"
              control={control}
              render={({ field }) => <Input {...field} placeholder={t("uploadAdmin.form.prefixPlaceholder")} />}
            />
          </FormItem>

          <FormItem label={t("uploadAdmin.form.schema")} tooltip={t("uploadAdmin.form.schemaHint")} className="mb-0">
            <Controller
              name="schemaId"
              control={control}
              render={({ field }) => (
                <Select
                  {...field}
                  placeholder={t("uploadAdmin.form.schemaPlaceholder")}
                  allowClear
                  loading={schemasLoading}
                  options={schemaOptions}
                />
              )}
            />
          </FormItem>

          <FormItem label={t("uploadAdmin.form.parser")} tooltip={t("uploadAdmin.form.parserHint")} className="mb-0">
            <Controller
              name="parser"
              control={control}
              render={({ field }) => (
                <Select
                  {...field}
                  placeholder={t("uploadAdmin.form.parserPlaceholder")}
                  allowClear
                  options={[...PARSER_OPTIONS]}
                />
              )}
            />
          </FormItem>
        </div>
      </Form>
    </Card>
  );
}
